import * as React from "react";
const SvgEmptyFolder = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 119.381,
	height: 124.131,
	viewBox: "0 0 119.381 124.131",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_14",
	"data-name": "Group 14",
	transform: "translate(0 0)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_496",
	"data-name": "Path 496",
	d: "M519.377,169.076a2.534,2.534,0,0,0-1.4-2.548l-46.88-22.913a2.527,2.527,0,0,0-3.381,1.16v0l-17.583,35.975a2.532,2.532,0,0,0,1.161,3.382l46.88,22.913a2.532,2.532,0,0,0,3.382-1.161l17.583-35.975A2.508,2.508,0,0,0,519.377,169.076Z",
	transform: "translate(-400.01 -143.357)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_497",
	"data-name": "Path 497",
	d: "M409.806,314.108H348.976a2.892,2.892,0,0,1-2.889-2.889V228.641a2.892,2.892,0,0,1,2.889-2.889h60.829a2.892,2.892,0,0,1,2.889,2.889V311.22A2.892,2.892,0,0,1,409.806,314.108Z",
	transform: "translate(-317.903 -208.543)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_10",
	"data-name": "Ellipse 10",
	cx: 3.969,
	cy: 3.969,
	r: 3.969,
	transform: "translate(43.239 33.897)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_498",
	"data-name": "Path 498",
	d: "M408.2,361.992a11.368,11.368,0,0,0,1.754.808l.107.037a11.439,11.439,0,0,0,3.8.646c.261,0,.512-.009.746-.027a11.305,11.305,0,0,0,1.7-.234c.307-.067.612-.147.908-.238l.21-.065a11.528,11.528,0,0,0,3.353-1.737,5.175,5.175,0,0,0-.267-.449,5.728,5.728,0,0,0-4.8-2.591h-2.089A5.747,5.747,0,0,0,408.4,361.5,5.208,5.208,0,0,0,408.2,361.992Z",
	transform: "translate(-367.042 -313.279)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_499",
	"data-name": "Path 499",
	d: "M442.2,381.61a.756.756,0,0,0-.372.13,11.107,11.107,0,0,0,1.665-.231Z",
	transform: "translate(-393.645 -331.766)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_500",
	"data-name": "Path 500",
	d: "M394.354,273.083a11.606,11.606,0,0,0-5.79,21.664,11.408,11.408,0,0,0,1.844.858l.109.038a11.542,11.542,0,0,0,3.837.652c.253,0,.505-.008.754-.027a11.411,11.411,0,0,0,1.711-.236c.315-.069.625-.15.917-.24l.211-.065a11.607,11.607,0,0,0-3.593-22.644Zm6.734,20.3a11,11,0,0,1-3.332,1.757l-.2.063c-.278.086-.57.161-.871.226a10.7,10.7,0,0,1-1.619.226c-.236.017-.476.025-.714.025a10.975,10.975,0,0,1-3.632-.616l-.1-.036a10.7,10.7,0,0,1-1.83-.861,10.982,10.982,0,1,1,12.3-.783Z",
	transform: "translate(-346.905 -245.987)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_501",
	"data-name": "Path 501",
	d: "M364.676,494.922",
	transform: "translate(-332.608 -421.489)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_502",
	"data-name": "Path 502",
	d: "M409.806,314.108H348.976a2.892,2.892,0,0,1-2.889-2.889V228.641a2.892,2.892,0,0,1,2.889-2.889h60.829a2.892,2.892,0,0,1,2.889,2.889V311.22A2.892,2.892,0,0,1,409.806,314.108Zm-60.829-88.016a2.552,2.552,0,0,0-2.549,2.549V311.22a2.552,2.552,0,0,0,2.549,2.549h60.829a2.552,2.552,0,0,0,2.549-2.549V228.641a2.552,2.552,0,0,0-2.549-2.549Z",
	transform: "translate(-317.903 -208.543)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_503",
	"data-name": "Path 503",
	d: "M524.413,318.118H507.2a1.362,1.362,0,1,1,0-2.723h17.212a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-444.286 -279.46)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_504",
	"data-name": "Path 504",
	d: "M530.03,340.121H507.2a1.362,1.362,0,0,1,0-2.723h22.83a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-444.286 -296.868)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_505",
	"data-name": "Path 505",
	d: "M427.115,424.51h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-347.013 -363.63)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_506",
	"data-name": "Path 506",
	d: "M432.732,446.512H384.245a1.362,1.362,0,0,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -381.036)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_507",
	"data-name": "Path 507",
	d: "M427.115,497.083h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -421.044)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_508",
	"data-name": "Path 508",
	d: "M432.732,519.086H384.245a1.362,1.362,0,1,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -438.452)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_509",
	"data-name": "Path 509",
	d: "M427.115,569.656h-42.87a1.362,1.362,0,0,1,0-2.723h42.87a1.362,1.362,0,0,1,0,2.723Z",
	transform: "translate(-347.013 -478.459)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_510",
	"data-name": "Path 510",
	d: "M432.732,591.659H384.245a1.362,1.362,0,0,1,0-2.723h48.487a1.362,1.362,0,1,1,0,2.723Z",
	transform: "translate(-347.013 -495.866)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_511",
	"data-name": "Path 511",
	d: "M509.377,282.076a2.534,2.534,0,0,0-1.4-2.548l-46.88-22.913a2.527,2.527,0,0,0-3.381,1.16v0l-17.583,35.975a2.532,2.532,0,0,0,1.161,3.382l46.88,22.913a2.532,2.532,0,0,0,3.382-1.161l17.583-35.975a2.51,2.51,0,0,0,.242-.833Z",
	transform: "translate(-392.098 -232.755)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_512",
	"data-name": "Path 512",
	d: "M509.377,282.076a2.534,2.534,0,0,0-1.4-2.548l-46.88-22.913a2.527,2.527,0,0,0-3.381,1.16v0l-17.583,35.975a2.532,2.532,0,0,0,1.161,3.382l46.88,22.913a2.532,2.532,0,0,0,3.382-1.161l17.583-35.975a2.51,2.51,0,0,0,.242-.833Zm-18.092,36.678a2.234,2.234,0,0,1-2.984,1.025l-46.88-22.913a2.234,2.234,0,0,1-1.025-2.984l17.583-35.975a2.233,2.233,0,0,1,2.984-1.025l46.88,22.913a2.234,2.234,0,0,1,1.025,2.984Z",
	transform: "translate(-392.098 -232.755)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_513",
	"data-name": "Path 513",
	d: "M535.068,304.54l-12.278,25.12a.7.7,0,0,1-.941.324h0l-42.644-20.842a.591.591,0,0,1-.087-.051.7.7,0,0,1-.236-.89l12.278-25.12a.7.7,0,0,1,.941-.324h0L534.745,303.6a.7.7,0,0,1,.323.941h0Z",
	transform: "translate(-422.904 -253.583)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_514",
	"data-name": "Path 514",
	d: "M508.737,362.318l-27.219-13.3a.619.619,0,0,1-.1-.058l23.772-16.007a1,1,0,0,1,1.569.767l1.326,19.187.064.918Z",
	transform: "translate(-424.968 -293.21)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_515",
	"data-name": "Path 515",
	d: "M365.851,295.2l-9.293-4.542,7.8-4.4.562-.317.281-.159.064.918Z",
	transform: "translate(-282.082 -226.095)",
	opacity: .2
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_516",
	"data-name": "Path 516",
	d: "M595.591,426.013l-23.542-11.506,7.8-4.4.562-.317,10.165-5.73a1.339,1.339,0,0,1,1.838.766,1.2,1.2,0,0,1,.034.149Z",
	transform: "translate(-496.667 -349.497)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_517",
	"data-name": "Path 517",
	d: "M125.842,339.408H128.4l1.218-9.877h-3.78Z",
	transform: "translate(-99.556 -260.701)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_518",
	"data-name": "Path 518",
	d: "M333.868,516.174h5.043a3.214,3.214,0,0,1,3.214,3.214v.1h-8.257Z",
	transform: "translate(-308.235 -438.302)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_519",
	"data-name": "Path 519",
	d: "M30.551,330.254l2.653.519,3.264-9.986-3.916-.766Z",
	transform: "translate(-24.169 -253.177)",
	fill: "#ffb8b8"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_520",
	"data-name": "Path 520",
	d: "M236.727,507.59l5.225,1.022h0a3.393,3.393,0,0,1,2.678,3.981l-.021.108-8.555-1.673Z",
	transform: "translate(-230.853 -431.511)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_526",
	"data-name": "Path 526",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_527",
	"data-name": "Path 527",
	d: "M336.023,478.554H234.477a3.329,3.329,0,0,1-3.325-3.325V417.7a3.329,3.329,0,0,1,3.325-3.325,2.944,2.944,0,0,1,2.941,2.941V471.26a3.12,3.12,0,0,0,3.116,3.116H335.68a2.115,2.115,0,0,1,2.071,1.585,2.03,2.03,0,0,1-.9,2.336,1.586,1.586,0,0,1-.828.257Z",
	transform: "translate(-226.974 -357.765)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_530",
	"data-name": "Path 530",
	d: "M321.117,471.034H218.045a6.9,6.9,0,0,1-6.893-6.893v-56.6a6.9,6.9,0,0,1,6.893-6.893h12.637a6.877,6.877,0,0,1,4.636,1.792l13.7,9.786a4.842,4.842,0,0,0,3.271,1.268h69.463a6.893,6.893,0,0,1,6.892,6.993l-.64,43.759A6.922,6.922,0,0,1,321.117,471.034ZM218.045,401.061a6.482,6.482,0,0,0-6.475,6.475v56.6a6.482,6.482,0,0,0,6.475,6.475H321.117a6.5,6.5,0,0,0,6.474-6.38l.64-43.759a6.475,6.475,0,0,0-6.474-6.57H252.293a5.259,5.259,0,0,1-3.543-1.368l-13.7-9.786a6.461,6.461,0,0,0-4.364-1.691Z",
	transform: "translate(-211.152 -346.903)",
	fill: "#3f3d56"
})));
export default SvgEmptyFolder;
